import { PERSONALIZATION_API_HOST, PERSONALIZATION_API_KEY } from './constants';

const unsubscribeUser = async (email: string, country: string, formName: string[], pagePath: string) => {
  const body = {
    country,
    email,
    formName,
    pagePath,
  };

  const response = await fetch(`${PERSONALIZATION_API_HOST}/unsubscribeUser?`, {
    body: JSON.stringify(body),
    headers: {
      'x-api-key': PERSONALIZATION_API_KEY,
    },
    method: 'POST',
  });

  if (!response.ok) throw new Error('API error');

  return true;
};

export default unsubscribeUser;
